import { IHttpService, IPromise } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { CascadingLinkType, IPatchMetricLinks, MetricLinksSpec } from "@gtmhub/okrs/metrics";
import { GoalLinkType } from "@gtmhub/goals/goalLinkService";

export interface ICanLinkInfoRecord {
  canLink: boolean;
  reason: string;
}

export interface ICanLinkInfo {
  canLinkInfo: {
    [K in CascadingLinkType]: {
      [targetId: string]: ICanLinkInfoRecord;
    };
  };
}
type LinkSourceTargetType = "goals" | "metrics";
type LinkType = CascadingLinkType | GoalLinkType;

export class LinkService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public unlink(sourceType: string, sourceId: string, linkType: LinkType, targetType: LinkSourceTargetType, targetId: string): IPromise<void> {
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/${linkType}/${targetType}/${targetId}`);

    return this.$http.delete<boolean>(url).then(() => null);
  }

  public link(sourceType: LinkSourceTargetType, sourceId: string, linkType: LinkType, targetType: LinkSourceTargetType, targetId: string): IPromise<void> {
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/${linkType}/${targetType}/${targetId}`);

    return this.$http.post<void>(url, null).then((response) => response.data);
  }

  public bulkLink(args: { sourceType: LinkSourceTargetType; sourceId: string; body: MetricLinksSpec }): IPromise<void> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}`);

    return this.$http.post<void>(url, body).then((response) => response.data);
  }

  public patchLinks(args: { sourceType: LinkSourceTargetType; sourceId: string; body: IPatchMetricLinks }): IPromise<void> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}`);

    return this.$http.patch<void>(url, body).then((response) => response.data);
  }

  public checkIfCanLink(args: { sourceType: LinkSourceTargetType; sourceId: string; body: MetricLinksSpec }): IPromise<ICanLinkInfo> {
    const { sourceType, sourceId, body } = args;
    const url = this.env.getApiEndpoint(`/links/${sourceType}/${sourceId}/can-link-info`);

    return this.$http.post<ICanLinkInfo>(url, body).then((response) => response.data);
  }
}
